
    import I18n from 'i18nObj';
    
      import 'translations/instructure_date_and_time';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('instructure_date_and_time');
  